import { userService } from '../_services';
import { router } from '../_helpers';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user}
    : { status: {}, user: null}

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        auth(context, idToken) {
            context.commit('loginRequest')
            userService.auth(idToken)
                .then(user => {
                    context.commit('loginSuccess', user)
                    router.push({ path: '/' })
                },
                error => {
                    context.commit('loginFailure', error)
                    context.dispatch('alert/error', error, { root: true })
                })
        },
        logout({ commit }) {
            userService.logout();
            commit('logout');
            router.push({ path: '/login' })
        },
    },
    mutations: {
        clientId(state, clientId) {
            state.clientId = clientId
        },
        loginRequest(state) {
            state.status = { loggingIn: true };
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        }
    },
    getters: {
        userAvatar(state) {
            if (state.user.avatar){
                return { isImage: true, url: state.user.avatar }
            }
            return { isImage: false, url: null }
        }
    }
}
